import React from "react";

export default function Spacer(props) {
  return (
    <div style={{flexGrow: 1}}></div>
  );
}
